import { render, staticRenderFns } from "./create-for-student-has-no-enroll.vue?vue&type=template&id=03861804&"
import script from "./create-for-student-has-no-enroll.vue?vue&type=script&lang=js&"
export * from "./create-for-student-has-no-enroll.vue?vue&type=script&lang=js&"
import style0 from "./create-for-student-has-no-enroll.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports